// extracted by mini-css-extract-plugin
export var marginNegative = "_5h-5 _5h-3 _5h-1";
export var marginPositive = "_5h-4 _5h-3 _5h-1";
export var modalContent = "_5h-6";
export var samplesTable = "_5h-8";
export var samplesTableContainer = "_5h-7";
export var statBox = "_5h-a";
export var tableCell = "_5h-1";
export var tableCellCenter = "_5h-2 _5h-1";
export var tableCellRight = "_5h-3 _5h-1";
export var tableHeader = "_5h-0";
export var trackingNumber = "_5h-9";